import _extends from '@babel/runtime/helpers/extends';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { __rest } from '../../../dependencies/tslib/tslib.es6.js';
import React__default, { useState, useRef, useCallback } from 'react';
import './InputFile.scss.js';
import Button from '../Button/Button.js';
import { validateFilesAsync } from './file-utils.js';
import Attachment from '../../molecules/Attachment/Attachment.js';

var InputFile = function InputFile(_a) {
  var _a$name = _a.name,
      name = _a$name === void 0 ? '' : _a$name,
      _a$accept = _a.accept,
      accept = _a$accept === void 0 ? '*' : _a$accept,
      _a$multiple = _a.multiple,
      multiple = _a$multiple === void 0 ? true : _a$multiple,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      _a$placeholder = _a.placeholder,
      placeholder = _a$placeholder === void 0 ? '' : _a$placeholder,
      _a$files = _a.files,
      files = _a$files === void 0 ? [] : _a$files,
      setFile = _a.setFile,
      onError = _a.onError,
      maxSize = _a.maxSize,
      count = _a.count,
      _a$showChips = _a.showChips,
      showChips = _a$showChips === void 0 ? true : _a$showChips,
      customPlaceholder = _a.customPlaceholder;
      _a.customDownloadMethod;
      var _a$showRemoveIcon = _a.showRemoveIcon,
      showRemoveIcon = _a$showRemoveIcon === void 0 ? true : _a$showRemoveIcon,
      renderCustomErrors = _a.renderCustomErrors,
      props = __rest(_a, ["name", "accept", "multiple", "className", "disabled", "placeholder", "files", "setFile", "onError", "maxSize", "count", "showChips", "customPlaceholder", "customDownloadMethod", "showRemoveIcon", "renderCustomErrors"]);
  /** Файл */


  var _useState = useState(function () {
    return files;
  }),
      _useState2 = _slicedToArray(_useState, 2),
      file = _useState2[0],
      uploadFile = _useState2[1];
  /** Ссылка на инпут */


  var ref = useRef(null);

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var clearError = function clearError() {
    setError(undefined);
  };

  var handleError = function handleError(newError) {
    onError === null || onError === void 0 ? void 0 : onError(newError);
    setError(newError);
  };
  /** Получаем картинку */


  var onChange = function onChange() {
    if (ref.current && ref.current.files) {
      var arrFiles = Array.from(ref.current.files).slice(0, count);
      validateFilesAsync(arrFiles, {
        maxSize: maxSize,
        accept: accept
      }).then(function (data) {
        Promise.all(data).then(function (result) {
          var newFiles = [];

          if (multiple) {
            var keysMap = {};
            var next = [].concat(_toConsumableArray(file), _toConsumableArray(result)).slice(0, count);
            next.forEach(function (f) {
              if (!keysMap[f.file.name + f.file.lastModified]) {
                keysMap[f.file.name + f.file.lastModified] = true;
                newFiles.push(f);
              }
            });
          } else {
            newFiles.push.apply(newFiles, _toConsumableArray(result));
          }

          clearError();
          setFile(newFiles);
          uploadFile(newFiles);

          if (ref && ref.current) {
            ref.current.value = '';
          }
        })["catch"](function () {
          handleError({
            fileUpload: true
          });
        });
      })["catch"](function (err) {
        handleError(err);
      });
    }
  };
  /** Программный клик по инпуту */


  var onClick = function onClick(e) {
    e.preventDefault();
    e.stopPropagation();

    if (ref.current) {
      ref.current.click();
    }
  }; // =======================================================================================================================================


  var _onRemove = useCallback(function (index) {
    var newListFile = file;
    newListFile.splice(index, 1);

    if (!newListFile.length) {
      uploadFile([]);
      setFile([]);
    } else {
      uploadFile(_toConsumableArray(newListFile));
      setFile(_toConsumableArray(newListFile));
    }
  }, [file]); // =======================================================================================================================================


  return /*#__PURE__*/React__default.createElement("div", {
    className: "rf-file-input__wrapper",
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("label", {
    className: "".concat(className || ''),
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("input", {
    ref: ref,
    type: "file",
    name: name,
    accept: accept,
    className: "rf-input__file-hidden",
    placeholder: placeholder || 'Выберите файл',
    disabled: disabled,
    onChange: onChange,
    multiple: multiple,
    "data-v-6e52f9c7": ""
  }), /*#__PURE__*/React__default.createElement(Button, _extends({}, props, {
    type: "button",
    onClick: onClick,
    disabled: disabled,
    "data-v-6e52f9c7": ""
  }), customPlaceholder || placeholder)), showChips && file.length > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-file-input__attachments",
    "data-v-6e52f9c7": ""
  }, file.map(function (attachment, index) {
    return /*#__PURE__*/React__default.createElement(Attachment, {
      key: index,
      attachment: attachment,
      showRemoveIcon: showRemoveIcon,
      onRemove: function onRemove() {
        return _onRemove(index);
      },
      "data-v-6e52f9c7": ""
    });
  })), renderCustomErrors && error && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-file-input__custom-error",
    "data-v-6e52f9c7": ""
  }, renderCustomErrors(error)));
};

export { InputFile as default };
